import { useMemo } from 'react'
import { SitemodelManifestStateGrouped } from 'sitemodel/shared/types/sitemodel.type'

export default function useSitemodelStateGrouping(
  state: Record<string, object>
) {
  const { globalComponents } = globalThis

  return useMemo(() => {
    const result: SitemodelManifestStateGrouped = {
      querystring: {},
      filteraction: {},
      credential: {},
      applicationsystem: {}
    }

    Object.keys(state).forEach((key) => {
      if ('filteraction' in state[key]) {
        result.filteraction[key] = state[
          key
        ] as SitemodelManifestStateGrouped['filteraction']['']
      }

      if ('querystring' in state[key]) {
        result.querystring[key] = state[
          key
        ] as SitemodelManifestStateGrouped['querystring']['']
      }

      if ('credential' in state[key]) {
        result.credential[key] = state[
          key
        ] as SitemodelManifestStateGrouped['credential']['']
      }

      if ('applicationsystem' in state[key]) {
        result.applicationsystem[key] = state[
          key
        ] as SitemodelManifestStateGrouped['applicationsystem']['']
      }
    })

    if (globalComponents?.length > 0) {
      const globalComponentsStates: Record<
        string,
        SitemodelManifestStateGrouped['filteraction']['']
      > = globalComponents.reduce((acc, globalComponent) => {
        if (globalComponent?.state) {
          acc = { ...acc, ...globalComponent.state }
        }

        return acc
      }, {})

      Object.entries(globalComponentsStates).forEach(([key, value]) => {
        result.filteraction[key] =
          value as SitemodelManifestStateGrouped['filteraction']['']
      })
    }

    return result
  }, [state, globalComponents])
}
